import type { Styles } from '@adornis/ass/style.js';
import { XChip } from '@adornis/chemistry/elements/components/x-chip.js';
import type { ColorType } from '@adornis/chemistry/elements/theming/coloring-system.js';
import { customElement, property } from 'lit/decorators.js';

export enum TrChipMode {
  FILLED = 'filled',
  OUTLINED = 'outlined',
}

@customElement('tr-chip')
export class TrChip extends XChip {
  @property({ attribute: true }) coloring?: ColorType;
  @property({ attribute: true }) mode?: TrChipMode; // Default FILLED

  protected get _curMode() {
    return this.mode ?? TrChipMode.FILLED;
  }
  protected get _curColor() {
    return this.coloring ?? this.colors.accent;
  }
  protected get _curTextColor() {
    const c = this._curColor;
    return this._curMode === TrChipMode.FILLED ? this._curColor.on(c.shade(50).raw, c.shade(900).raw) : this._curColor;
  }

  protected get _currentStyling() {
    switch (this.mode) {
      case TrChipMode.OUTLINED:
        return {
          background: 'TRANSPARENT',
          color: this._curColor,
          border: `1px solid ${this._curColor}`,
        };
    }

    // Default
    return {
      background: this._curColor,
      color: this._curTextColor,
    };
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          userSelect: 'none',
          borderRadius: this.sizes.borderRadius,

          '&[symmetrical]': {
            padding: this.spacing.xs,
          },
        },
      },
      {
        ':host': this._currentStyling,
      },
    ] as Styles[];
  }
}
